import { useCallback, type ReactElement } from 'react'
import FilterChip from 'LuxKit/Chips/FilterChip'
import type { ChatCartCategory } from './chatCartItems'

interface Props {
  category: ChatCartCategory
  /** Already composed with its count, e.g. "Flights 1". */
  label: string
  icon: ReactElement | undefined
  isSelected: boolean
  onSelect: (category: ChatCartCategory) => void
}

function ChatCartCategoryChip({ category, label, icon, isSelected, onSelect }: Props) {
  const handleClick = useCallback(() => {
    onSelect(category)
  }, [onSelect, category])

  // FilterChip hides its label text from the accessibility tree (the layout reserves
  // space with a visibility:hidden copy), so name the control explicitly.
  return (
    <FilterChip
      size="small"
      selected={isSelected}
      startIcon={icon}
      onClick={handleClick}
      aria-label={label}
      aria-pressed={isSelected}
    >
      {label}
    </FilterChip>
  )
}

export default ChatCartCategoryChip
